import _Card from "@mui/material/Card";
import _CardActionArea from "@mui/material/CardActionArea";
import _CardContent from "@mui/material/CardContent";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import _Skeleton from "@mui/material/Skeleton";
import _Avatar from "@mui/material/Avatar";
import _Button from "@mui/material/Button";
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import communityImage from '../assets/images/community.svg';
import { CommunityJoinDialog } from './community-join-dialog';
import { CompanyIcon, LockOutlinedIcon } from './icons';
function ItemContent({
  Button: CustomButton,
  currentUser,
  geogroup,
  joined,
  openJoinDialog,
  handleTryToJoinAsGuest
}) {
  const {
    t
  } = useTranslation();
  const Button = CustomButton || _Button;
  return /*#__PURE__*/React.createElement(_CardContent, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      height: '100%',
      '&&': {
        padding: 2
      }
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0
  }, geogroup ? /*#__PURE__*/React.createElement(_Avatar, {
    src: geogroup.photo || communityImage,
    sx: {
      height: 60,
      width: 60
    }
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 60,
    variant: "circular",
    width: 60
  })), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: "calc(100% - 76px)"
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    width: "100%"
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 600,
    sx: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    variant: "body1",
    width: "100%"
  }, geogroup ? geogroup.title : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 200
  })), geogroup && /*#__PURE__*/React.createElement(React.Fragment, null, geogroup.type === 'company' ? /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 0.5
  }, /*#__PURE__*/React.createElement(CompanyIcon, {
    color: "primary",
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "primary",
    lineHeight: 1,
    variant: "caption"
  }, t('commons.communities.joined_communities.company'))) : geogroup.type !== 'city' && !geogroup.openMembership && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 0.5
  }, /*#__PURE__*/React.createElement(LockOutlinedIcon, {
    color: "primary",
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "primary",
    lineHeight: 1,
    variant: "caption"
  }, t('commons.communities.joined_communities.private')))), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, geogroup ? t('commons.communities.members', {
    count: geogroup.nbMembers
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))))), !joined && geogroup && /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Button, {
    disableElevation: true,
    color: "primary",
    disabled: currentUser === undefined,
    onClick: () => currentUser !== null ? openJoinDialog?.(true) : handleTryToJoinAsGuest?.(),
    size: "small",
    variant: "contained"
  }, t('commons.communities.actions.join', {
    context: geogroup.type === 'company' ? 'company' : ''
  }))));
}
export function CommunityItem({
  Button,
  Dialog,
  currentUser,
  geogroup,
  joined,
  handleClick,
  handleCommunityJoined,
  handleTryToJoinAsGuest
}) {
  const [joinDialogOpen, openJoinDialog] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Card, {
    sx: {
      borderRadius: '10px',
      width: {
        xs: '100%',
        sm: 'calc((100% - 24px) / 2)',
        lg: 'calc((100% - 48px) / 3)'
      }
    },
    variant: "outlined"
  }, geogroup && joined && handleClick ? /*#__PURE__*/React.createElement(_CardActionArea, {
    onClick: () => handleClick(geogroup),
    sx: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(ItemContent, {
    joined: true,
    Button: Button,
    currentUser: currentUser,
    geogroup: geogroup
  })) : /*#__PURE__*/React.createElement(ItemContent, {
    Button: Button,
    currentUser: currentUser,
    geogroup: geogroup,
    handleTryToJoinAsGuest: handleTryToJoinAsGuest,
    joined: joined,
    openJoinDialog: openJoinDialog
  })), /*#__PURE__*/React.createElement(CommunityJoinDialog, {
    Button: Button,
    currentUser: currentUser,
    Dialog: Dialog,
    geogroup: geogroup,
    onClose: async (geogroup, data) => {
      if (geogroup) {
        if (data?.waiting) {
          enqueueSnackbar(t('commons.communities.join_dialog.asked'));
        } else {
          handleCommunityJoined?.(geogroup.id);
        }
      } else openJoinDialog(false);
    },
    open: joinDialogOpen
  }));
}